// import store from '@/store'
import consts from "@/consts";
const routes = !consts.app.$isTestVersion ? [] : [
    {
        path: '/icons',
        name: 'icons',
        meta: {
        },
        components: {
            default: () => import('@/views/test/IconsPage.vue'),
        },
    },
    {
        path: '/unit-galery',
        name: 'unit-galery',
        meta: {
        },
        components: {
            default: () => import('@/views/test/UnitGaleryPage.vue'),
        },
    },
]

export default routes